import type { LegalDocument } from "../legal/LegalDocument.js";

/** Dumb View for a LegalDocument. */
export function LegalPage({ doc }: { doc: LegalDocument }) {
  return (
    <article className="site-legal t-legal" data-page="legal">
      <p className="t-legal-draft" role="note">
        <strong>{doc.banner}</strong>
      </p>
      <h1>{doc.title}</h1>
      <p className="t-note">Last updated {doc.updated}</p>
      {doc.sections.map((s) => (
        <section key={s.heading}>
          <h2>{s.heading}</h2>
          {s.paragraphs.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </section>
      ))}
    </article>
  );
}
